

define([], function () {

    var contingencyList = {
        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
        INTERNAL_ERROR: 'errorInternalError',
        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
        SETTLEMENT_DENIED: 'errorInstrumentRefused',
        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_IBAN: 'invalidPINumber',
        INVALID_IBAN_CODE: 'invalidPINumber',
        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
        INVALID_BANK_ADDRESS: 'errorGeneral',
        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
        INVALID_SECURITY_CODE: 'errorInvalidCSC',
        INVALID_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_LAST_NAME: 'errorInvalidLastName',
        INVALID_EXPIRY: 'errorInvalidExpirationDate',
        INVALID_PHONE: 'errorInvalidPhone',
        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
        EMPTY_DATA: 'errorGeneral',
        ISSUER_DECLINE: 'errorIssuerReject',
        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
        TRANSACTION_TIMEOUT: 'transactionTimeout',
        NOT_CONFIRMED: 'notConfirmed',
        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
        RESTRICTED_CARD: 'cardRestricted',
        RESTRICTED_CARD_GUEST: 'cardRestrictedGuest',
        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
        DUPLICATED_TRANSACTION: 'duplicateTransaction'

    };

    return contingencyList;
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/fi-contingency-list/contingencies.js
// module id = ./components/xo-wallet-components/src/fi-contingency-list/contingencies.js
// module chunks = 1